import React from "react";
import { Link, useParams } from "react-router-dom";

import "./OrderSuccess.css";

const OrderSuccess = () => {
  const { orderId } = useParams();

  return (
    <main className="order-success-page">
      <div className="order-success-card">
        <div className="order-success-icon">✓</div>

        <p className="order-success-eyebrow">STAR GOLD</p>

        <h1>Order Received</h1>

        <p className="order-success-message">
          Thank you for shopping with STAR GOLD.
          <br />
          Your order has been successfully received.
        </p>

        <div className="order-success-number">
          <span>ORDER ID</span>

          <strong>#{orderId}</strong>
        </div>

        <div className="order-success-payment">
          <span>Payment</span>

          <strong>CONFIRM SEPARATELY</strong>
        </div>

        <p className="order-success-note">
          Our team will contact you regarding payment and delivery details.
        </p>

        <div className="order-success-actions">
          <Link to="/track-order" className="order-success-primary">
            Track Your Order
          </Link>

          <Link to="/collections" className="order-success-secondary">
            Continue Shopping
          </Link>
        </div>
      </div>
    </main>
  );
};

export default OrderSuccess;
